import React from "react";
import {PropsWithChildren} from "react";
import {WithScene} from "../../../interfaces/UX";
import {ActionButton} from "../../../components/action-button/ActionButton";

export type WithCornerActions = {
    markCorner: () => void;
    undoCorner: () => void;
    undoVisible: boolean;
};

export const DOFloorMarker = (props: PropsWithChildren<WithScene & WithCornerActions>) => {

    const undoButtonStyle: React.CSSProperties = {
        right: '128px',
        bottom: '32px',
        borderWidth: '0px',
        borderRadius: '24px',
        backgroundColor: '#eb6e65',
        width: '48px',
        height: '48px',
        textAlign: 'center',
        lineHeight: '48px',
    };

    return (
        <>
            <ActionButton onClick={props.markCorner}>
                Mark
            </ActionButton>
            {props.undoVisible && (
                <ActionButton onClick={props.undoCorner} style={undoButtonStyle}>
                    Undo
                </ActionButton>
            )}
        </>
    );
};
